import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDebouncedCallback } from 'use-debounce';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import * as Styled from './styled';

function QueryInput({
  onQueryTermChange,
  dataGtm,
  placeholder,
  debounceDelay,
}) {
  const [queryTerm, setQueryTerm] = useState('');

  const debouncedOnChange = useDebouncedCallback(
    onQueryTermChange,
    debounceDelay
  );

  const syncQueryTerm = nextQueryTerm => {
    setQueryTerm(nextQueryTerm);
    debouncedOnChange(nextQueryTerm);
  };

  return (
    <Styled.QueryInputRow>
      <Styled.SearchIcon />
      <Styled.QueryInput
        placeholder={placeholder}
        onChange={e => syncQueryTerm(e.target.value)}
        value={queryTerm}
        dataGtm={dataGtm}
      />
      {queryTerm !== '' && (
        <Styled.ClearSearchButton onClick={() => syncQueryTerm('')}>
          <Styled.ClearSearchIcon />
          <ScreenReaderText>
            <FormattedMessage id="routes.clearsearch_acc" />
          </ScreenReaderText>
        </Styled.ClearSearchButton>
      )}
    </Styled.QueryInputRow>
  );
}

QueryInput.propTypes = {
  /** Function passed input element's value and fired when that value changes */
  onQueryTermChange: PropTypes.func.isRequired,
  /** Optional handle for google tag manager */
  dataGtm: PropTypes.string.isRequired,
  /** Displays a placeholder message in the input */
  placeholder: PropTypes.string,
  /** Amount of time to debounce input changes */
  debounceDelay: PropTypes.number,
};

QueryInput.defaultProps = {
  debounceDelay: 250,
  placeholder: '',
};

export default QueryInput;
